import Vue from 'vue'
import VueRouter from 'vue-router'
const home = () => import('@/views/home')
const detail = () => import('@/views/detail')
const jilu = () => import('@/views/jilu')

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'home',
    meta: {
      title: '首页',
      requireAuth: true,
    },
    component: home
  },{
	path: '/detail',
	name: 'detail',
	meta: {
	  title: '设备预约详情',
	  requireAuth: true,
	},
	component: detail  
  },{
	path: '/record',
	name: 'record',
	meta: {
	  title: '设备预约记录',
	  requireAuth: true,
	},
	component: jilu  
  }]

const router = new VueRouter({
    // mode: 'history',
    // base: '/asian/',
    routes
})

export default router